<template>
  <form class="needs-validation" @submit.prevent="$emit('make-order', form)" novalidate enctype="multipart/form-data">
    <p>
      После оформления заказа вы получите автоматическое подтверждение <span class="underline">с номером заказа</span>.
    </p>

    <p class="d-none">
      После оформления заказа вы получите автоматический ответ cо списком заказанного и
      <span class="underline">номером заказа</span>.
    </p>

    <p>
      Мы проверим наличие деталей и свяжемся с вами по телефону или почте. Если вы хотите задать вопрос по заказу –
      звоните и будьте готовы назвать номер заказа.
    </p>

    <p class="d-none">
      При заказе будут использованы данные из вашего профиля, заполненные в формы ниже. Вы можете исправить их, но они
      будут сохранены только в текущем заказе. Если вы хотите поменять данные в профиле – перейдите в
      <a :href="url.profile" class="text-decoration-underline">Редактирование профиля</a>.
    </p>
    <p class="d-none">
      Перед оформлением заказа проверьте, пожалуйста, контактные данные, а затем нажмите "Отправить заказ".<br />Если
      это не вы – нажмите <a :href="url.logout" class="text-decoration-underline">Выйти</a> и продолжите оформление
      заказа.
    </p>

    <div class="row mt-1 mb-3">
      <div class="col-12">
        <div data-error class="alert alert-info my-1 px-2 py-1" role="alert">
          Перед оформлением заказа проверьте, пожалуйста, контактные данные, а затем нажмите "Отправить заказ"
        </div>
      </div>
    </div>

    <!-- тел -->
    <div class="row my-1">
      <label for="validation-phone" class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label"
        >Телефон</label
      >
      <div class="col-3 col-sm-3 col-md-2 col-xxl-2 pe-0">
        <select v-model="obj.country.phone" class="form-select">
          <option v-for="el in countries" :key="el.value" :value="el.value">
            {{ el.text }}
          </option>
        </select>
      </div>
      <div class="col-9 col-sm-5 col-md-4 col-lg-6 col-xxl-5">
        <input
          v-maska="obj.phone"
          :data-maska="obj.mask.phone"
          type="tel"
          name="phone"
          v-model="form.phone"
          @maska="onMaskaPhone"
          class="form-control"
          id="validation-phone"
          :class="{
            'is-invalid': obj.phone.unmasked.length && !obj.phone.completed,
            'is-valid': obj.phone.completed,
          }"
          :placeholder="obj.mask.phone.replaceAll('#', 'x')" />
      </div>
    </div>

    <!-- имя -->
    <div class="row my-1">
      <label for="validation-name" class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label"
        >Имя и фамилия</label
      >
      <div class="col-12 col-sm-8 col-md-6 col-lg-8 col-xxl-7">
        <input type="text" name="fullname" class="form-control" id="validation-name" v-model="form.fullname" />
      </div>
    </div>

    <!-- email -->
    <div class="row my-1">
      <label for="validation-email" class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label"
        >Адрес эл. почты</label
      >
      <div class="col-12 col-sm-8 col-md-6 col-lg-8 col-xxl-7">
        <input
          type="email"
          name="email"
          class="form-control"
          placeholder="адрес эл. почты"
          id="validation-email"
          v-model="form.email" />
      </div>
    </div>

    <!-- доставка -->
    <div class="row mt-1 mb-2">
      <label class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label">Доставка</label>
      <div class="col-12 col-sm-8 form-check__wrapper">
        <div class="form-check">
          <input
            type="radio"
            name="deliverytype"
            class="form-check-input"
            id="withlogin-deliverytype1"
            value="1"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="withlogin-deliverytype1">Заберу самостоятельно</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="deliverytype"
            class="form-check-input"
            id="withlogin-deliverytype2"
            value="2"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="withlogin-deliverytype2"
            >Доставка по С.-Петербургу
            <small class="text-muted"><a href="/dostavka" target="_blank">стоимость и какие районы?</a></small></label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="deliverytype"
            class="form-check-input"
            id="withlogin-deliverytype3"
            value="3"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="withlogin-deliverytype3"
            >Отправка ТК
            <small class="text-muted"><a href="/dostavka#tk" target="_blank">какие ТК используем?</a></small></label
          >
        </div>
      </div>
    </div>

    <!-- тк -->
    <div class="row mt-1 mb-2" v-show="form.deliverytype == 3">
      <label for="validation-tk" class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label"
        >Транспортная компания</label
      >
      <div class="col-12 col-sm-8 col-md-6 col-lg-8 col-xxl-7">
        <select name="tk" class="form-select" id="validation-tk" v-model="form.tk">
          <option v-for="el in values.tklist" :key="el.id" :value="el.id">{{ el.name }} {{ el.comment }}</option>
        </select>
        <small class="text-muted"
          >Мы отправляем все заказы в жёсткой обрешетке, потому что это требование транспортных компаний к отправке
          автодеталей.</small
        >
      </div>
    </div>

    <!-- адрес -->
    <div class="row mt-1 mb-2" v-show="form.deliverytype == 2 || form.deliverytype == 3">
      <label class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label">Адрес доставки</label>
      <div class="col-12 col-sm-8 col-md-6 col-lg-8 col-xxl-7 position-relative">
        <VueSuggestions
          :model.sync="form.address"
          :coordinates.sync="form.coordinates"
          :placeholder="'Начните вводить'"
          class="form-control"
          :options="suggestionOptions">
        </VueSuggestions>
      </div>
    </div>

    <hr />

    <!-- комментарий -->
    <div class="row my-1">
      <label for="validation-comment" class="col-12 col-sm-4 col-lg-3 col-form-label text-sm-end form-label"
        >Комментарий к заказу</label
      >
      <div class="col-12 col-sm-8 col-md-6 col-lg-8 col-xxl-7">
        <textarea
          name="comment"
          class="form-control"
          id="validation-comment"
          placeholder=""
          v-model="form.comment"></textarea>
      </div>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="row mb-1 mt-2">
      <div
        class="col-12 col-sm-8 offset-sm-4 col-md-7 offset-md-3 col-lg-8 col-xl-9 offset-xl-2 col-xxl-7 offset-xxl-3 text-sm-end pt-2">
        <button class="btn btn-primary" type="submit">Отправить заказ</button>
      </div>
    </div>
  </form>
</template>

<script>
import VueSuggestions from 'vue-suggestions';
import { vMaska } from 'maska';

export default {
  directives: { maska: vMaska },
  data: function () {
    return {
      form: {
        _token: this.csrf,
        //
        phone: this.values.phone,
        fullname: this.values.fullname,
        email: this.values.email,
        //
        deliverytype: this.values.deliverytype,
        tk: this.values.tk,
        comment: '',
        address: this.values.address,
        coordinates: {
          latitude: '',
          longitude: '',
        },
      },
      errors: {
        form: {
          phone: '',
          fullname: '',
          email: '',
          //
          common: '',
        },
      },
      // для работы maska
      obj: {
        phone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        raw: {
          phone: '',
        },
        country: {
          phone: '?',
        },
        mask: {
          phone: '',
        },
      },
      // справочники для maska
      countries: [
        // https://apps.timwhitlock.info/emoji/tables/iso3166
        { text: '🇷🇺', code: 'RU', value: '7', mask: '+7 (###) ###-##-##', compare: '+7 ' }, // 7 XXX XXX-XX-XX // россия (+ казахстан)
        { text: '🇧🇾', code: 'BY', value: '375', mask: '+375 ## ###-##-##', compare: '+375 ' }, // 375 XX XXX-XX-XX // белоруссия
        // { text: '🇦🇲', code: 'AM', value: '374', mask: '+374 ### ###-##', compare: '+374 ' }, // 374 XXX XXX-XX // армения
        // { text: '🇱🇻', code: 'LV', value: '371', mask: '+371 ### ## ###', compare: '+371 ' }, // 371 XXX XX XXX // латвия
        // { text: '🇱🇹', code: 'LT', value: '370', mask: '+370 ### #####', compare: '+370 ' }, // 370 XXX XXXXX // литва
        // { text: 'другой', code: '??', value: '?', mask: '', compare: '' }, // другое, что попало
      ],
      default: {
        country: '7',
        mask: '+7 (###) ###-##-##',
      },
      // datata token
      token: process.env.VUE_APP_DADATA_API_KEY,
      // dadata
      suggestionOptions: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: process.env.VUE_APP_DADATA_API_KEY,
        type: 'ADDRESS',
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        //onSelect(suggestion) { },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    url: {
      type: Object,
      default() {
        return {};
      },
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    VueSuggestions,
  },
  methods: {
    onMaskaPhone(event) {
      this.obj.raw.phone = event.detail.unmasked;
    },
  },
  watch: {
    'obj.country.phone'(newVal) {
      this.obj.mask.phone = this.countries.filter((el) => el.value == newVal)[0].mask;
      this.form.phone = this.obj.raw.phone;
    },
  },
  mounted() {
    // maska
    this.obj.country.phone = this.default.country;
    this.obj.mask.phone = this.default.mask;
  },
};
</script>

<style lang="scss">
.form-check__wrapper {
  padding-top: calc(0.375rem + var(--bs-border-width));
}
.form-select__country {
  max-width: 85px;
}
</style>
